import { useEffect, useState } from "react";
import { CiViewList } from "react-icons/ci";
import { BsSearch } from 'react-icons/bs';
import { RiArrowDownSFill } from "react-icons/ri";
import { RxCross1 } from 'react-icons/rx';
import Pagination from "../../components/Pagination";
import { format } from "date-fns";
import { IoEye } from "react-icons/io5";
import useGroup from "../../hook/useGroup";
import { formatDateTimeForDisplay } from "../../utils/getUserDateFormat";
import Cookies from "js-cookie";
import { EmailLogDetailPopup } from "./EmailLogDetailPopup";
import { getEmailLogsBySearch } from "../../services/EmailLog";

const heading = [
    "View",
    "Recipient",
    "Subject",
    "Status",
    "Sent By",
    "Sent At"
];

export const EmailLogs = () => {
    const token = Cookies.get("token-my-cdir");
    const { selectedGroupId }: any = useGroup();
    const [searchValue, setSearchValue] = useState<string>("");
    const [displayFilter, setDisplayFilter] = useState<boolean>(false);
    const [notificationFilterValue, setNotificationFilterValue] = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
        page: 0,
        size: 10
    });
    const [totalLength, setTotalLength] = useState<number>(0);
    const [selectedFilter, setSelectedFilter] = useState<string>("Recipient Email");
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [showEntries, setShowEntries] = useState<number>(10);
    const [openLogPopup, setOpenLogPopup] = useState<boolean>(false);
    const [selectedLog, setSelectedLog] = useState<any>(null);

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                size: paginationModel.size
            };

            setPaginationModel(newPaginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (selectedGroupId > 0) {
            if (searchValue === "") {
                setIsFirstTime(false)
                apiCall(paginationModel);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    useEffect(() => {
        setPaginationModel({
            page: 0,
            size: paginationModel.size
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroupId])

    const apiCall = async (newPaginationModel: { page: number, size: number }) => {
        setIsDataLoaded(true);
        await getEmailLogsBySearch(selectedGroupId, "", newPaginationModel.page, newPaginationModel.size, token!)
            .then(data => {
                const result = data.emailLogs.map((item: any) => {
                    return {
                        ...item,
                        sentAt: item.sentAt ? format(new Date(item.sentAt), "MM/dd/yyyy hh:mm a") : "No date",
                    };
                })

                setSearchTableData(result);
                setTotalLength(data.count);
                setIsDataLoaded(false);

            }).catch((error) => {
                console.log(error);
                setIsDataLoaded(false);
                setSearchTableData([]);
                setTotalLength(0);
            });
    }

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    size: paginationModel.size,
                };

                setPaginationModel(newPaginationModel);

            }, 1000);
        }

        return () => clearTimeout(timeOutId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "") {
            filteApiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const filteApiCall = async (newPaginationModel: { page: number, size: number }) => {
        setIsDataLoaded(true);
        switch (notificationFilterValue) {
            case 0:
                await getEmailLogsBySearch(selectedGroupId, searchValue, newPaginationModel.page, newPaginationModel.size, token!)
                    .then(data => {
                        const result = data.emailLogs.map((item: any) => {
                            return {
                                ...item,
                                sentAt: item.sentAt ? format(new Date(item.sentAt), "MM/dd/yyyy hh:mm a") : "No date",
                            };
                        })
                        setSearchTableData(result);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);
                    }).catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });
                break;
        }
    }

    const applyFilter = () => {
        setSelectedFilter("Recipient Email");
        setSearchValue("");
        setDisplayFilter(false);
    }

    const clearFilter = () => {
        setSearchValue("");
        setDisplayFilter(false);
    }

    return (
        <section className="user__container p-3 xm:p-4 overflow-x-hidden">
            <div className="min-w-full flex flex-col xm:flex-row justify-between items-start xm:items-center gap-3">
                <h1 className="px-2 xm:px-4 py-1.5 flex items-center gap-2">
                    <CiViewList fontSize={20} />
                    <span className="text-base xm:text-lg">Email Logs</span>
                </h1>
            </div>

            <div className="flex flex-col xm:flex-row gap-3 justify-between xm:items-center border border-black p-2 mt-4">
                <div className="relative flex flex-col xm:flex-row gap-3 items-start xm:items-center w-full">
                    <div className="relative w-full xm:w-auto">
                        <button
                            className="bg-secondary text-white px-3 py-2 xm:py-1 rounded-md flex items-center justify-between w-full xm:w-auto whitespace-nowrap"
                            onClick={() => setDisplayFilter(!displayFilter)}
                        >
                            {selectedFilter}
                            <RiArrowDownSFill className="ml-1" />
                        </button>

                        <div className={`${displayFilter ? "block" : "hidden"} absolute z-10 w-full xm:w-40 p-2 bg-white border border-black mt-2 xm:mt-0 xm:top-0 xm:left-full`}>
                            <div className="flex justify-between">
                                <label className="text-xs font-bold">Fields</label>
                                <div
                                    onClick={() => setDisplayFilter(false)}
                                    className="w-4 h-4 cursor-pointer text-sm text-center"
                                >
                                    <RxCross1 />
                                </div>
                            </div>

                            <select
                                className="w-full text-xs py-1 border mt-1"
                                value={notificationFilterValue}
                                onChange={(e) => setNotificationFilterValue(parseInt(e.target.value))}
                            >
                                <option value="0">Recipient Email</option>
                            </select>

                            <div className="flex mt-2 justify-between">
                                <button
                                    className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                                    onClick={() => applyFilter()}
                                >
                                    Apply Filter
                                </button>

                                <button
                                    className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full ml-1"
                                    onClick={() => clearFilter()}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center gap-2 w-full border px-2 py-1 rounded xm:border-none">
                        <div className="h-4 w-4 text-gray-900">
                            <BsSearch />
                        </div>

                        <input
                            type="text"
                            placeholder="Search…"
                            className="w-full text-sm xm:text-lg pl-2 outline-none"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="mt-2" />

            {
                !isDataLoaded
                    ? (
                        <>
                            <div className="w-full overflow-x-auto">
                                <table className="min-w-[800px] w-full bg-white">
                                    <thead className="bg-gray-200 whitespace-nowrap">
                                        <tr>
                                            {
                                                heading.map((item, index) => (
                                                    <th
                                                        key={index}
                                                        className="px-4 xm:px-6 py-2 text-left text-xs xm:text-sm font-semibold text-black"
                                                    >
                                                        {item}
                                                    </th>
                                                ))
                                            }
                                        </tr>
                                    </thead>

                                    <tbody className="whitespace-nowrap">
                                        {
                                            searchTableData.length > 0
                                                ? (
                                                    searchTableData.slice(0, showEntries).map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            className="even:bg-blue-50"
                                                        >
                                                            <td className="px-4 xm:px-6 py-2">
                                                                <button
                                                                    type="button"
                                                                    className="mr-4"
                                                                    onClick={() => {
                                                                        setSelectedLog(item);
                                                                        setOpenLogPopup(true);
                                                                    }}
                                                                    title="View Email details"
                                                                >
                                                                    <IoEye style={{ color: "#3b82f6" }} />
                                                                </button>
                                                            </td>

                                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                                {item.toEmail || "-"}
                                                            </td>

                                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm max-w-[300px] truncate">
                                                                {item.subject || "-"}
                                                            </td>

                                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                                <span
                                                                    className={`px-2 py-1 rounded-full text-xs font-medium ${item.status === "Sent"
                                                                            ? "bg-green-100 text-green-700"
                                                                            : item.status === "Delivered"
                                                                                ? "bg-blue-100 text-blue-700"
                                                                                : item.status === "Failed"
                                                                                    ? "bg-red-100 text-red-700"
                                                                                    : item.status === "Pending"
                                                                                        ? "bg-yellow-100 text-yellow-700"
                                                                                        : "bg-gray-100 text-gray-700"
                                                                        }`}
                                                                >
                                                                    {item.status || "-"}
                                                                </span>
                                                            </td>
                                                           
                                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                                {item.createdBy || "-"}
                                                            </td>

                                                            <td className="px-4 xm:px-6 py-2 text-xs xm:text-sm">
                                                                {item.sentAt ? formatDateTimeForDisplay(item.sentAt) : "-"}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan={6}
                                                            className="px-2 py-1 text-sm text-center h-52"
                                                        >
                                                            No data available
                                                        </td>
                                                    </tr>
                                                )
                                        }
                                    </tbody>
                                </table>
                            </div>

                            {
                                totalLength > 0 && (
                                    <div className="mt-6 flex flex-col xm:flex-row items-center justify-between gap-3">
                                        <Pagination
                                            pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                                            totalLength={totalLength}
                                            paginationModel={paginationModel}
                                            setPaginationModel={setPaginationModel}
                                            showEntries={showEntries}
                                            setShowEntries={setShowEntries}
                                        />
                                    </div>
                                )
                            }
                        </>
                    ) : (
                        <div className="min-w-full h-[300px] xm:h-[480px] flex justify-center items-center">
                            <div className="flex flex-col items-center">
                                <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-r-transparent text-secondary"></div>
                                <span className="text-sm mt-2">Loading...</span>
                            </div>
                        </div>
                    )
            }

            <EmailLogDetailPopup
                data={selectedLog}
                setShowModal={setOpenLogPopup}
                showModal={openLogPopup}
            />
        </section>
    )
}